import { ILang } from './../interfaces';

export const availableLangs: Record<string, ILang> = {
  en: {
    code: 'en',
    label: 'English'
  },
  el: {
    code: 'el',
    label: 'Ελληνικά'
  },
  default: {
    code: 'el',
    label: 'Ελληνικά'
  }
};
